var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-12"},[_c('Hero'),_vm._v(" "),_c('Roles'),_vm._v(" "),_c('Perks'),_vm._v(" "),_c('Power'),_vm._v(" "),_c('Earn'),_vm._v(" "),_c('Pro')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }